import axios from "axios";
import bugContext from "./bugContext";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("stancor_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Per-session database routing (Odoo-style): send chosen DB pre-login / on public endpoints
  const dbName = localStorage.getItem("stancor_db");
  if (dbName) {
    config.headers["X-DB-Name"] = dbName;
  }
  // Attach company_id to all requests
  const companyId = localStorage.getItem("stancor_company_id");
  if (companyId) {
    config.params = { ...config.params, company_id: companyId };
  }
  // Attach FY filter to GET requests (backend endpoints that support it will use it)
  if (config.method === "get") {
    const fy = localStorage.getItem("stancor_fy");
    if (fy) {
      config.params = { ...config.params, fy };
    }
  }
  return config;
});

let _redirecting = false;

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // Track API failures for bug reporter
    if (err.response && err.response.status >= 400) {
      bugContext.addApiFailure(
        err.config?.method, err.config?.url,
        err.response.status, err.response.statusText,
        err.response.data
      );
    }
    if (err.response?.status === 401 && !err.config?.url?.startsWith("/auth/")
        && !err.config?.url?.startsWith("/cafe/pantry/")
        && !window.location.pathname.startsWith("/pantry")
        && !window.location.pathname.startsWith("/cafe/kiosk")) {
      localStorage.removeItem("stancor_token");
      localStorage.removeItem("stancor_user");
      // Redirect only once and never when already on /login
      if (!_redirecting && !window.location.pathname.startsWith("/login")) {
        _redirecting = true;
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
